import RecentBlog from "../components/blog/blog_recent.jsx";
import BlogData from "../data/blog.json";
export default function BlogInfo() {
    const location = window.location.pathname;
    const url = location.split("/blog/")[1];
    const blog_post = BlogData.find(post => post.url === url);
    document.title = "Blog - CGES.CLUB";
    
    // Assign random 6 recent blogs for the sidebar (excluding the current blog post)
    const recent_news_card_data = BlogData.filter(post => post.url !== url).sort(() => 0.5 - Math.random()).slice(0, 6);
    // console.log("Blog post data:", recent_news_card_data);
    return (
        <div class="uk-grid uk-grid-custom" data-uk-grid>
            <div class="uk-width-3-3@l uk-width-3-5@m">
                {/* <h3 className="uk-text-lead">Blogs</h3> */}
                <p className='container card text-white' style={{backgroundColor:"transparent",cursor:"pointer"}} onClick={()=>{
                window.history.back();
            }}>{"<- BACK"}</p>
                <div class="uk-grid  uk-child-width-2-2@l uk-child-width-2-2@m uk-child-width-1-1@s">
                    <section class="b-post b-post-full b-post-single clearfix">
                        <div class="entry-media">
                            <img class="img-fluid" src={"/images/blog/"+blog_post.url+".png"} alt="Foto" />
                            <div class="entry-meta">
                                <span class="entry-meta__item">{blog_post.date}</span>
                                {/* <span class="entry-meta__item"><a class="entry-meta__link" href="blog-main.html"><i class="ic icon-speech"></i>53</a></span> */}
                            </div>
                        </div>
                        <div class="entry-main">
                            <div class="entry-content">
                                <h1
                                    class="entry-title"
                                    style={{
                                        display: "-webkit-box",
                                        WebkitBoxOrient: "vertical",
                                        WebkitLineClamp: 2,
                                        overflow: "hidden",
                                        textOverflow: "ellipsis"
                                    }}
                                >
                                    {blog_post.title}
                                </h1>
                                <div dangerouslySetInnerHTML={{ __html: blog_post.desc }} />
                            </div>
                        </div>
                    </section>
                </div>
            </div>

            <div class="uk-width-1-5@l uk-width-2-5@m">

                <aside class="l-sidebar">
                    {/* <div class="widget widget-search section-sidebar bg-light">
                        <div class="widget-title bg-dark"><i class="ic ico_search"></i>search</div>
                        <div class="widget-inner">
                            <form class="form-sidebar" id="search-global-form">
                                <input class="form-sidebar__input form-control" type="search" placeholder="keyword"/>
                                    <button class="form-sidebar__btn"><i class="ic icon-magnifier"></i></button>
                            </form>
                        </div>
                    </div> */}

                    {/* <section class="widget section-sidebar bg-light">
                        <h3 class="widget-title bg-dark"><i class="ic icon-list"></i>categories</h3>
                        <div class="widget-content">
                            <div class="widget-inner">
                                <ul class="widget-list list list-mark-4">

                                    <li class="widget-list__item"><a class="widget-list__link" href="blog-post.html"> Fighting games</a></li>
                                    <li class="widget-list__item"><a class="widget-list__link" href="blog-post.html"> Beat 'em up games</a></li>
                                    <li class="widget-list__item"><a class="widget-list__link" href="blog-post.html"> Stealth game</a></li>
                                    <li class="widget-list__item"><a class="widget-list__link" href="blog-post.html">Action-adventure</a></li>
                                    <li class="widget-list__item"><a class="widget-list__link" href="blog-post.html"> Survival horror</a></li>
                                    <li class="widget-list__item"><a class="widget-list__link" href="blog-post.html">Text adventures</a></li>
                                    <li class="widget-list__item"><a class="widget-list__link" href="blog-post.html"> Graphic adventures</a></li>
                                    <li class="widget-list__item"><a class="widget-list__link" href="blog-post.html"> Interactive movie</a></li>


                                </ul>
                            </div>
                        </div>
                    </section> */}

                    <section class="widget section-sidebar bg-light">
                        <h3 class="widget-title bg-dark"><i class="ic icon-calendar"></i>recent blogs</h3>
                        <div class="widget-content">
                            <div class="widget-inner">

                                {recent_news_card_data.length > 0 ? (
                                    <>
                                        {recent_news_card_data.map((card, index) => (
                                            <RecentBlog key={index} data={card} />
                                        ))}
                                    </>
                                ) : (

                                    <p>No recent blogs available</p>

                                )}

                            </div>
                        </div>
                    </section>

                    {/* <section class="widget section-sidebar bg-light">
                        <h3 class="widget-title bg-dark"><i class="ic icon-tag"></i>tags cloud</h3>
                        <div class="widget-content">
                            <div class="widget-inner">
                                <ul class="list-tags list-unstyled">
                                    <li class="list-tags__item"><a class="list-tags__link" href="blog-post.html">Article</a></li>
                                    <li class="list-tags__item"><a class="list-tags__link" href="blog-post.html">Keyword</a></li>
                                    <li class="list-tags__item"><a class="list-tags__link" href="blog-post.html">Domain</a></li>
                                    <li class="list-tags__item"><a class="list-tags__link" href="blog-post.html">Backlink</a></li>
                                    <li class="list-tags__item"><a class="list-tags__link" href="blog-post.html">Compressor</a></li>
                                    <li class="list-tags__item"><a class="list-tags__link" href="blog-post.html">Video</a></li>
                                    <li class="list-tags__item"><a class="list-tags__link" href="blog-post.html">Facebook</a></li>
                                    <li class="list-tags__item"><a class="list-tags__link" href="blog-post.html">Gaming</a></li>
                                    <li class="list-tags__item"><a class="list-tags__link" href="blog-post.html">Word</a></li>
                                    <li class="list-tags__item"><a class="list-tags__link" href="blog-post.html">PDF</a></li>
                                    <li class="list-tags__item"><a class="list-tags__link" href="blog-post.html">RGB</a></li>
                                    <li class="list-tags__item"><a class="list-tags__link" href="blog-post.html">GIF Converter</a></li>
                                </ul>
                            </div>
                        </div>
                    </section> */}
                </aside>
            </div>
        </div>
    );
}
